import { render, staticRenderFns } from "./venue_editor.vue?vue&type=template&id=cb8050bc&"
import script from "./venue_editor.vue?vue&type=script&lang=js&"
export * from "./venue_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8050bc')) {
      api.createRecord('cb8050bc', component.options)
    } else {
      api.reload('cb8050bc', component.options)
    }
    module.hot.accept("./venue_editor.vue?vue&type=template&id=cb8050bc&", function () {
      api.rerender('cb8050bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/venues/venue_editor.vue"
export default component.exports